'use client';
import * as React from 'react';
import { VisualAssessmentBoxProps } from './VisualAssessmentBox.types';
import RateBars from '../RateBars/RateBars';
import { BadgeVisualRate } from '../Badge/Badge';

function VisualAssessmentBox({
  rating,
  className = '',
}: VisualAssessmentBoxProps) {
  const backgroundColors = [
    'bg-red-800', // rating 1 - POOR (bardzo zła)
    'bg-orangeBright', // rating 2 - BELOW_AVERAGE (zła) - orangeBright
    'bg-[#73C69B]', // rating 3 - GOOD (adekwatna do przebiegu)
    'bg-green-700', // rating 4 - EXCELLENT (dobra)
  ];

  return (
    <div
      className={`flex overflow-hidden flex-col justify-center items-start px-6 py-5 font-bold bg-white rounded-2xl border border-emerald-300 border-solid shadow-2xl max-w-[404px] ${className}`}
    >
      <div className="flex gap-8 items-center">
        <RateBars
          maxRating={4}
          rating={rating}
          backgroundColors={backgroundColors}
        />
        <div className="my-auto flex w-[227px] flex-col gap-2">
          <div className="text-sm leading-snug text-left lg:text-xl text-text-primary">
            Wizualna ocena zużycia
          </div>
          <BadgeVisualRate rating={rating} />
        </div>
      </div>
    </div>
  );
}

export default VisualAssessmentBox;
